// 配置主机地址和端口号（可以有多个，需要测试那个环境字节打开那个base即可）124.71.190.109  this.$Api.orderPay   this.$Api.pmlistOrder   /base/base_property.po
//let base = "http://api.ysf51.com:9292"
 //let base = "http://user-api.yishifu.com"
 // let base = "http://124.71.190.109:9090"
 // let workerinfo = "http://124.71.190.109:9292"
  //let base = "http://192.168.3.93:9090"
//let base = "http://test-user-api.yishifu.com"
//let base = "http://124.71.190.109:9393"

  let base = "https://admin-api.yishifu.com"
  let workerinfo = "https://worker-info.yishifu.com"
  let obs = "https://obs.yishifu.com"
// 在线api接口路径，需要和项目后台确认
let online_url = {
 //登录退出
    userLogin:  base + "/admin/login.po",    //密码登录/worker/pmlist_view_worker_all.do
	userWorker:  base + "/worker/pmlist_view_worker_all.do",    //师傅信息/worker/pmlist_view_worker_all.do
    serviceCategory:   base + "/base/base_service_category.po",//服务类目get
	serviceMode:   base + "/base/base_service_mode.po",//服务类型/
	delWorker:   base + "/worker/worker_unregister.do",//服务类目
	workerCertification:   base + "/worker/worker_certification.do",//师傅人工审核
















	userVcode:  base + "/user/login_vcode.po",  //验证码登录
	userLogout: base + "/user/logout.po",//退出
	userMsg:    base + "/user/msg_send_for_login.po",//获取验证码
	
	
 //注册
   registerMsg:   base + "/user/msg_send_for_register.po",    //注册获取验证码
   register:      base + "/user/register.po",    //注册后登录
   
//修改密码
   editPassMsg:   base + "/user/msg_send_for_find_pwd.po",//修改密码取验证码
   editPassPwd:   base + "/user/find_pwd.po",//修改密码
	
//订单列表
	pmlistOrder:   base + "/order/pmlist_order.do",//订单列表
	orderDetail:   base + "/order/order_detail.do",//订单详情
	orderQuoted:   base + "/order/mlist_order_quoted.do",//师傅报价
	orderAppoint:   base + "/order/order_operate_appoint.do",//师傅报价
	  
 //订单操作
	orderCancel:   base + "/order/order_operate_cancel.do",//取消订单
	orderDelete:   base + "/order/order_operate_delete.do",//删除订单
	
	//基础数据
	serviceCategory:   base + "/base/base_service_category.po",//服务类目get
	serviceMode:   base + "/base/base_service_mode.po",//服务类型/
	serviceCommodity:   base + "/base/base_commodity.po",//服务类型
	serviceProperty:   base + "/base/base_property.po",//商品属性
	
	
	userCommodityAll:   base + "/user/user_commodity_all.do",//添加商品库
	userCommodityClassified:   base + "/user/user_commodity_classified_statistic.do",//添加商品库---总
	userCommodityDelete:   base + "/user/user_commodity_delete.do",//删除商品库产品
	userCommodityAdd:   base + "/user/user_commodity_add.do",//添加商品库产品
	
	//最近一次下单记忆
	orderRecent:   base + "/order/order_detail_recent.do",//最近一次下单
	
	//支付
	orderTransaction:   base + "/order/order_operate_transaction.do",//订单支付详情 
	orderPay:   base + "/order/order_operate_choose_pay_type.do",//订单支付详情
	
	
	//地址识别
	addressParse:   base + "/sys/sys_address_parse.do",//地址识别
	
	//下单联系人
	userContact:         base + "/user/user_contact_person.do",//下单联系人
	userContactDelete:   base + "/user/user_contact_person_delete.do",//删除联系人
	// 提交商品库
	userCommodityAdd:   base + "/user/user_commodity_add.do",//删除联系人
	
	//提交订单
	orderPublish:   base + "/order/order_publish.do",//提交订单
	
	
	//物流信息
	baseExpress:   base + "/base/base_express.po",//物流公司
	sysLogistic:   base + "/sys/sys_logistic_query.do",//快递查询	

	//订单查询
	
	orderSearch:   base + "/order/pmlist_order.do",//订单查询
	
	
	//用户信息
	userProfile:   base + "/user/user_profile.do",//查询用户信息h
	userProfileEdit:   base + "/user/user_profile_edit.do",//修改用户信息
	
	//支付
	orderTransaction:   base + "/order/order_operate_transaction.do",//订单支付生成交易单号(交易第一步)
	orderPay:   base + "/order/order_operate_choose_pay_type.do",//订单支付详情(交易第二步)
	
	//支付相关/order/order_operate_payment_by_wallet.do
	userWallet:   base + "/user/user_wallet.do",//钱包
	userSecretPassword:   base + "/user/user_secret_password_check.do",//用户钱包支付密码检查
	userSetPassword:   base + "/user/user_secret_password_set.do",//用户钱包支付密码设置
	userPayment:   base + "/order/order_operate_payment_by_wallet.do",//用户钱包支付提交
	userMsgSetPwd:   base + "/user/msg_send_for_set_secret_pwd.do",//设置支付密码验证码
	orderOperateVerify:   base + "/order/order_operate_payment_verify.do",//订单-操作-第三方付款查询(支付第三步)
	orderOperateGet:   base + "/order/order_operate_payment.do",   //订单-操作-付款提交(支付第四步)
	

	// 师傅查询
	infoWorker:  workerinfo + "/info/worker_info_list.po", // 师傅列表
	infoWorkerDetail:  workerinfo + "/info/worker_info_detail.po", //师傅详情
	infoWorkerImageList:  workerinfo + "/info/order_complete_image_list.po", //师傅详情完工照片
	infoWorkerStat:  workerinfo + "/info/order_complete_stat.po", //师傅详情完工照片分类统计
	//确认验收
	orderFinish:   base + "/order/order_operate_finish.do",   //订单-操作-付款提交(支付第四步)
	
	
	//全国地址
	address:   obs + "/json/address.json",   //全国地址
	
	//obs
	obs: obs ,   //obs
	
	
}
//导出online_url对象
export default online_url